<template>
	<div class="scrollbar">
		<el-scrollbar :style='scrollbarStyle'>
			<el-menu
				class="el-menu-vertical"
        :style="{ width: this.$i18n.locale === 'zh_CN' ? '178px' : '250px' }"
				background-color="#ffffff"
				text-color="#888888"
				:show-timeout="200"
				:default-active="$route.path"
				:collapse="collapsed"
				:mode="mode"
				:router="true"
				:unique-opened="unique"
				@select="selectMenu"
			>
				<template v-for="item in menu">
					<sidebar-item
						v-if="item.children && item.children.length !== 0"
						:parent-item="item"
						:key="'menu-'+ item.path"
					></sidebar-item>
					<el-menu-item v-else :index="item.path" :route="item.route" :key="'menu-'+ item.id">
						<i class="icon" :class="item.icon"></i>
						<span>{{ $t(item.name) }}</span>
					</el-menu-item>
				</template>
			</el-menu>
		</el-scrollbar>
	</div>
</template>

<script>
import { mapMutations } from 'vuex';
import SidebarItem from './sidebar-item';

export default {
  name: 'sidebar',
  props: {
    menu: {
      type: Array,
      default: () => []
    },
    collapsed: Boolean
  },
  data() {
    return {
      mode: 'vertical',
      isCollapse: false,
      activeName: '1',
      unique: true
    };
  },
  computed: {
    scrollbarStyle() {
      // 根据collapsed的值动态返回样式对象
      return {
        height: '100%',
        width: this.collapsed ? '0' : 'auto'
      };
    }
  },
  methods: {
    ...mapMutations({
      setTag: 'SET_TAG'
    }),
    selectMenu(path) {
      this.setTag({
        tag: {
          path
        }
      });
      let currentPage = JSON.parse(window.sessionStorage.currentPage);
      currentPage.path = path;
      window.sessionStorage.setItem('currentPage', JSON.stringify(currentPage));
    }
  },
  components: {
    SidebarItem
  }
};
</script>

<style lang="scss" scoped>
.scrollbar {
  height: 100%;
  .el-menu-vertical:not(.el-menu--collapse) {
    width: 178px;
    border: none;
  }
}
</style>
<style lang="scss">
.scrollbar {
  .el-menu {
    &.el-menu--inline {
      .el-menu-item {
        background-color: $-background-sidbar !important;
      }
    }
  }
  .el-menu-item,
  .el-submenu__title {
    color: #333333 !important;
    height: 42px;
    line-height: 42px;
    background-color: $-background-sidbar !important;
  }
  .el-submenu .el-menu-item {
    height: 42px;
    line-height: 42px;
    padding: 0 40px;
    min-width: 178px;
  }
  .el-menu-item.is-active {
    color: #ff8037 !important;
  }
}
</style>
